// Import Node packages first
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import Buefy from 'buefy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueHeadful from 'vue-headful';
import numeral from 'numeral';
// Import Store and Routers
import Store from './app/app-state';
import Routes from './app/app-routes';
// Import Plugins
import FontAwesome from './platform/fontAwesome';
import HasFeature from './platform/hasFeature';
// import HasPermission from './platform/hasPermission';
import HasRole from './platform/hasRole';
import { SignInType, createOidcAuth, LogLevel } from './platform/vueOidcClient';
import SetupStorage from './platform/localForage';
import KyAnalytics from './platform/kyNalytics';
// import './registerServiceWorker' // <- Comment out during development
// Import Custom components
import DetailField from './app/shared/DetailFieldComponent.vue';
import DetailFieldV2 from './app/shared/DetailFieldComponentV2.vue';
import App from './app/App.vue';

// Use Statements and Setup
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(FontAwesome);
Vue.use(Buefy, {
  defaultIconPack: 'far',
  defaultIconComponent: FontAwesomeIcon
});
Vue.component('vue-headful', VueHeadful); // dynamic <meta> tag
// Vue.use(HasPermission);
Vue.use(HasRole);
Vue.use(HasFeature);
SetupStorage();
Vue.config.productionTip = false;
const siteUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/`;

// Fetch app configuration, check if the API is live, then
// choose the correct load function
(async () => {
  const configFile = window.location.hostname && window.location.hostname.includes('localhost') ? 'config.Development' : 'config';
  const res = await fetch(`/${configFile}.json`);
  const cfg = await res.json();
  const supportConfRes = await fetch('/config-support.json');
  const supportCfg = await supportConfRes.json();
  cfg.support = supportCfg;

  // eslint-disable-next-line no-use-before-define
  loadApp(cfg);
})();

// Build OIDC object to use in loading functions
const buildOIDC = (cfg) => createOidcAuth('kppnext', SignInType.Window, siteUrl, {
  authority: cfg.authDomain,
  client_id: cfg.clientId,
  response_type: cfg.responseType,
  scope: cfg.scopes
}, console, cfg.logLevel || LogLevel.Error);

// This is fired off when the configuration fetches
// These components depend on configuration, so they have
// to be loaded last
let mainOidc = null;
const loadApp = (cfg) => {
  // Create router for main app
  const router = new VueRouter({
    routes: Routes(Vue.prototype.$hasRole, Vue.prototype.$hasFeature),
    mode: 'history'
  });

  // Authentication
  mainOidc = buildOIDC(cfg, siteUrl);
  mainOidc.useRouter(router);

  // Instantiate a store
  const store = Store(cfg, router);

  // Load KyNalytics
  Vue.use(KyAnalytics, { 
    router, 
    store,
    analytics: {
      enabled: cfg.analyticsEnabled,
      telemetryUrl: cfg.telemetryUrl || 'not provided'
    }, 
    errors: { 
      enabled: cfg.errorLoggingEnabled, 
      console: cfg.consoleErrorLogging 
    } 
  });

  // Load app
  mainOidc.startup().then(ok => {
    if (ok) {
      Object.defineProperty(Vue.prototype, '$auth', { value: mainOidc });
      Object.defineProperty(Vue.prototype, '$numeral', { value: numeral });

      // Define the environment in config
      // eslint-disable-next-line no-param-reassign
      if (window.location.hostname && window.location.hostname.includes('localhost')) cfg.environment = 'development';
      // Define the DetailField component, since we use it globally
      Vue.component('detail-field', DetailField);
      Vue.component('detail-field-2', DetailFieldV2);

      new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
    }
  });

  window.$auth = mainOidc;
}
